import React, { useEffect } from 'react';
import { toast } from 'sonner';

import { useAppDispatch, useAppSelector } from 'js/store/hooks';
import { hideCallout } from 'js/actionCreators/uiActions';
import { ReactComponent as IconOffline } from 'imgs/svg-icons/IconOffline.svg';
import { ReactComponent as IconError } from 'imgs/svg-icons/IconError.svg';
import { ReactComponent as IconTick } from 'imgs/svg-icons/IconTick.svg';

import Spinner from '../Spinner';
import Toast from '../Toast';

import useGetNextAction from './useGetNextAction';

import './Callout.css';

const Callout = () => {
  const dispatch = useAppDispatch();
  const showCallout = useAppSelector(({ ui }) => ui.showCallout);
  const nextAction = useGetNextAction(showCallout?.callToAction);

  useEffect(() => {
    if (showCallout) {
      const handleOnDismiss = () => dispatch(hideCallout());
      const actionBtn = () => {
        if (!showCallout?.callToAction || !nextAction) return;
        const handleOnClick = () => dispatch(nextAction);
        return (
          <button className="Callout__cta" onClick={handleOnClick}>
            {showCallout.callToAction.label}
          </button>
        );
      };

      let icon = null;
      if (!showCallout || (showCallout.isError && !showCallout.icon) || showCallout.icon === 'error') {
        icon = <IconError />;
      } else if ((!showCallout.isError && !showCallout.icon) || showCallout.icon === 'tick') {
        icon = <IconTick />;
      } else if (showCallout.icon === 'offline') {
        icon = <IconOffline />;
      } else if (showCallout.icon === 'loading') {
        icon = <Spinner icon />;
      }

      const message = (
        <span>
          <span>{showCallout && showCallout.details}</span>
          {showCallout?.callToAction && actionBtn()}
        </span>
      );

      toast.custom(
        id => (
          <Toast
            title={showCallout.title}
            description={message}
            type={showCallout.isError ? 'error' : 'default'}
            icon={icon}
            showDismissButton={showCallout.autoDismiss === false}
            onDismiss={() => {
              toast.dismiss(id);
              handleOnDismiss();
            }}
          />
        ),
        {
          duration: showCallout.autoDismiss === false ? Infinity : undefined,
          onDismiss: handleOnDismiss,
          onAutoClose: handleOnDismiss
        }
      );
    }
  }, [showCallout, nextAction, dispatch]);

  return null;
};

export default Callout;
